"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PAID: "paid",
    UNPAID: "unpaid",
    NOT_APPLICABLE: "not-applicable"
};
